import { DefaultError, useQuery, UseQueryResult } from '@tanstack/react-query';
import { Invoice } from '../../../../../types/invoices/Invoices';
import { ServiceFactory } from '../../../../../services/ServiceFactory';

interface Props {
  dates: {
    fromDate: string;
    toDate: string;
  };
  paymentStatusFilter?: string;
  isLegacy?: boolean;
  orderNumber?: string;
}

const invoicingService = ServiceFactory.createInvoiceService();

export default function useGetInvoicesQuery(
  parameters: Props,
): UseQueryResult<Invoice[], DefaultError> {
  return useQuery({
    queryKey: ['getInvoices', parameters],
    queryFn: async () => invoicingService.getInvoices<Invoice[]>(parameters),
    /* Disable auto fetching, because of `continuationToken` it will return a 400 if we over fetch boundaries */
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
